import { render, staticRenderFns } from "./QuestionWheelCHair.vue?vue&type=template&id=65075005&scoped=true"
import script from "./QuestionWheelCHair.vue?vue&type=script&lang=js"
export * from "./QuestionWheelCHair.vue?vue&type=script&lang=js"
import style0 from "./QuestionWheelCHair.vue?vue&type=style&index=0&id=65075005&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65075005",
  null
  
)

export default component.exports